import { request } from 'data/requests/request';
import * as queryString from 'querystring';

const listRequest = (data, type: string = 'productList') => {
    const query = queryString.stringify(data);
    return request({ type, url: `list/filter/index?${query}`, notApi: true, force: true });
};

export default listRequest;
